import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DestaquesAplicativoService {
  BASEURL: string;
  httpHeaders: HttpHeaders;

  constructor(private http: HttpClient) {
    this.BASEURL = environment.apiUrl;

    this.httpHeaders = new HttpHeaders({
      Authorization: localStorage.getItem('tokenMappe'),
    });
  }

  listaDestaque(id: string): Observable<any> {
    return this.http.get(`${this.BASEURL}/highlights/brand/${id}`, {
      headers: this.httpHeaders,
    });
  }

  listaItemDestaque(id: string): Observable<any> {
    return this.http.get(`${this.BASEURL}/highlights/${id}`, {
      headers: this.httpHeaders,
    });
  }

  salvaDestaque(body: any): Observable<any> {
    return this.http.post(`${this.BASEURL}/highlights`, body, {
      headers: this.httpHeaders,
    });
  }

  editarItemDestaque(id: string, body: any): Observable<any> {
    return this.http.put(`${this.BASEURL}/highlights/${id}`, body, {
      headers: this.httpHeaders,
    });
  }

  excluirItemDestaque(id: string): Observable<any> {
    return this.http.delete(`${this.BASEURL}/highlights/${id}`, {
      headers: this.httpHeaders,
    });
  }
}
